import { Course, Genre, Menu, MenuBook, SubGenre, SubMenuGroup } from '../../models';
import ChildSubMenuGroupRowList from '../ChildSubMenuGroupRowList';
import SubMenuRow from '../SubMenuRow';

export interface SubMenuRowListProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  menu: Menu;
  subMenuGroup: SubMenuGroup;
}

function SubMenuRowList({ menuBook, course, genre, subgenre, menu, subMenuGroup }: SubMenuRowListProps) {
  return (
    <>
      {subMenuGroup.sub_menus.map((subMenu) => (
        <SubMenuRow
          key={`submenu-${subMenu.id}`}
          menuBook={menuBook}
          course={course}
          genre={genre}
          subgenre={subgenre}
          menu={menu}
          subMenuGroup={subMenuGroup}
          subMenu={subMenu}
        >
          <ChildSubMenuGroupRowList
            menuBook={menuBook}
            course={course}
            genre={genre}
            subgenre={subgenre}
            menu={menu}
            subMenuGroup={subMenuGroup}
            subMenu={subMenu}
          />
        </SubMenuRow>
      ))}
    </>
  );
}

export default SubMenuRowList;
